/**
 * Retourne les valeurs attendues par l’API pour la création d’un message de contact
 * @param data
 * @return {object}
 */
export default function contactSerialize(data) {
  return {
    ref: data?.roomReference,
    type: data?.type,
    firstname: data?.firstname,
    lastname: data?.lastname,
    email: data?.email,
    phone: data?.phone,
    subject: data?.subject,
    message: data?.message,
    capacity: data?.capacity,
    checkin: data?.checkin,
    checkout: data?.checkout,
    token: data?.token,
  };
}
